import React from 'react';
import { Box } from 'remodeling-web-mobile-sdk-ui';
import styled from 'styled-components';
import { LayerPopUp } from '@/providers/LayerPopUpProvider';
import { Address } from '@remodeling/remodeling-manager';
import Header from '../Header';
import useSearchZoneCode from './hooks/useSearchZoneCode';
import SearchZoneCodeInput from './SearchZoneCodeInput';
import SearchZoneCodeNoti from './SearchZoneCodeNoti';
import SearchZoneCodeResult from './SearchZoneCodeResult';
import { HEADER_HEIGHT } from '@/styles';
import TrackingService from '@/services/tracking';

interface SearchZoneCodeProps {
  handleChangeSiteData: (data: Address) => void;
}

const SearchZoneCode = ({ handleChangeSiteData }: SearchZoneCodeProps) => {
  const {
    handleChangeInput,
    inputValue,
    handleClickDelete,
    isSearchable,
    handleSearchSubmit,
    inputError,
    list,
    totalNum,
    handleReadMore,
    handleClickAddressItem,
    handleEmptySearch,
    setInputValue,
    inputRef,
  } = useSearchZoneCode({ handleChangeSiteData });

  return (
    <LayerPopUp
      id="SearchZoneCodeLayerPopUp"
      depth="MAX"
      direction="up"
      backgroundColor={'color_chip.white'}
      overflow="auto"
    >
      {({ handleClose }) => (
        <Box
          height="100%"
          backgroundColor={'color_chip.white'}
          {...TrackingService.tagGTM('search_zone_code')}
        >
          <Header
            title="우편번호 검색"
            right={[
              {
                type: 'CLOSE',
                handleClick: () => {
                  handleEmptySearch();
                  setInputValue('');
                  handleClose('SearchZoneCodeLayerPopUp');
                },
              },
            ]}
          />
          <Container>
            <SearchZoneCodeInput
              handleSearchSubmit={handleSearchSubmit}
              inputValue={inputValue}
              handleChangeInput={handleChangeInput}
              inputError={inputError}
              handleClickDelete={handleClickDelete}
              inputRef={inputRef}
            />
            <Box as="section">
              {isSearchable ? (
                <SearchZoneCodeResult
                  totalNum={totalNum}
                  list={list}
                  handleReadMore={handleReadMore}
                  handleClickAddressItem={handleClickAddressItem}
                  handleClose={handleClose}
                />
              ) : (
                <SearchZoneCodeNoti />
              )}
            </Box>
          </Container>
        </Box>
      )}
    </LayerPopUp>
  );
};

const Container = styled(Box)`
  height: calc(100% - ${HEADER_HEIGHT}px);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: none;
`;

export default SearchZoneCode;
